import React, { useEffect } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Text from '../../ui/Text';
import { detectMobile } from '../../utils/UiHelper';
import Wrapper from '../../ui/Wrapper';
import liveIcon from 'images/icons/MatchCenter/liveIcon.svg';
import matchCenterIcon from 'images/icons/MatchCenter/matchCenterIcon.svg';
import 'css/MatchCenter/index.scss';
import LiveStream from './LiveStream';

const MatchCenterAndLiveStream = ({
    matchCenter,
    streamId,
    sportId,
    groupName,
}) => {
    return (
        <>
            {streamId === null ? (
                matchCenter
            ) : (
                <Tabs className={'matchCenterTabs'}>
                    <Wrapper
                        margin={window.innerWidth < 1024 ? '0' : '0 0 13px'}
                        padding={'0'}
                        flex
                        flexDirection={
                            window.innerWidth < 1501 ? 'column' : 'row'
                        }
                        justify={
                            window.innerWidth < 1501 ? 'flex-start' : 'flex-end'
                        }
                        flexAlign={
                            window.innerWidth < 1501
                                ? 'flex-start'
                                : 'space-between'
                        }
                    >
                        {!detectMobile() ? (
                            <Text
                                margin={'0'}
                                padding={'0'}
                                size={'24'}
                                color={'#333333'}
                                bold
                                align={'left'}
                            >
                                Kampoversigt
                            </Text>
                        ) : null}
                        <TabList className={'TabsSwitcherWrapper'}>
                            <Tab>
                                <span>
                                    <img src={liveIcon} alt="" /> Se live
                                </span>
                            </Tab>
                            <Tab>
                                <span>
                                    <img src={matchCenterIcon} alt="" />{' '}
                                    Matchcenter
                                </span>
                            </Tab>
                        </TabList>
                    </Wrapper>

                    <TabPanel>
                        <LiveStream
                            streamId={streamId}
                            sportId={sportId}
                            groupName={groupName}
                        />
                    </TabPanel>
                    <TabPanel>{matchCenter}</TabPanel>
                </Tabs>
            )}
        </>
    );
};

export default MatchCenterAndLiveStream;
